var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1776081208781,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4404,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.253714 990.427429l479.085715-477.988572L38.253714 33.609143C26.441143 52.589714 18.285714 83.456 18.285714 127.890286v768.219428c0 44.434286 8.155429 75.264 19.968 94.354286z",
    fill: "#00D1FF",
    "p-id": 4405
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M719.725714 714.678857l-157.001143-157.769143L96.329143 1024h4.534857c39.899429 0 74.386286-14.518857 129.755429-44.470857l489.069714-264.850286z",
    fill: "#F7364A",
    "p-id": 4406
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M778.642286 341.028571l-170.569143 171.446858 170.569143 170.496 103.460571-56.246858c38.107429-20.845714 96.182857-58.953143 96.182857-114.249142 0-56.246857-58.075429-94.354286-96.182857-115.2L778.605714 340.992z",
    fill: "#FFCB02",
    "p-id": 4407
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.329143 0l466.395428 467.090286 156.964572-157.805715L230.619429 44.434286C175.250286 14.518857 140.763429 0 100.864 0h-4.534857z",
    fill: "#00F076",
    "p-id": 4408
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/googlePlay.aa81dab1c4fd09ede383ba4a552cbb5b.svg";
export { ForwardRef as ReactComponent };